import { Table } from '@tanstack/react-table';
import { PaginationControl } from '@/common/components/PaginationControl/PaginationControl';

interface TablePaginationControlProps<TData extends object> {
    table: Table<TData>;
    pageSizes: number[];
    isPaginated: boolean;
}

export const TablePaginationControl = <TData extends object>({
    table,
    pageSizes,
    isPaginated,
}: TablePaginationControlProps<TData>) => {
    return (
        <PaginationControl
            isPaginated={isPaginated}
            hasPreviousPage={table.getCanPreviousPage()}
            pageIndex={table.getState().pagination.pageIndex}
            hasNextPage={table.getCanNextPage()}
            pageSize={table.getState().pagination.pageSize}
            pageCount={Math.max(table.getPageCount(), 1)}
            pageSizes={pageSizes}
            setPageSize={(pageSize) => table.setPageSize(pageSize)}
            previousPage={() => table.previousPage()}
            nextPage={() => table.nextPage()}
            setPageIndex={(index) => table.setPageIndex(index)}
            itemCount={table.getRowCount()}
        />
    );
};
